import Emitter from './emitter';
import util from './util';

// browser mocks for testing
const hasWindow = (typeof window !== 'undefined');
const location = hasWindow ? window.location : {} as Location; // eslint-disable-line no-use-before-define
function MockWS() {
	this.close = function () {
		// intentionally empty
	};
}
const webSocketFactory = hasWindow ? (url, ...params) => new window.WebSocket(url, ...params) : () => new MockWS();

let _socket;
let _connectTimeout;
let _authToken;
let _keepAliveInterval; // this is need to keep ALB from closing the web socket connection
const _protocol = location.protocol === 'https:' ? 'wss:' : 'ws:';
const _uri = `${_protocol}//${location.host}`;
const _emitter = new Emitter();
const _uniqueClientKey = util.generateGuid(); // identifies this client as unique accross multiple logins per user

export default {
	_tryConnect: function () {
		clearTimeout(_connectTimeout);

		if (!_authToken) { return; }

		if (!_socket) {
			const webSocket = webSocketFactory(_uri) as WebSocket;
			const socket = {
				authToken: _authToken,
				isConnected: false,
				innerSocket: webSocket
			};

			webSocket.onopen = () => {
				webSocket.send(JSON.stringify({ type: 'auth', token: _authToken, uniqueClientKey: _uniqueClientKey }));
				_keepAliveInterval = setInterval(() => {
					webSocket.send(JSON.stringify({ type: 'ping' }));
				}, 50000);
			};

			webSocket.onclose = () => {
				clearInterval(_keepAliveInterval);
				socket.isConnected = false;
				if (socket === _socket) {
					_socket = null;
				}

				if (_authToken) {
					_connectTimeout = setTimeout(() => {
						this._tryConnect(_authToken);
					}, 10000);
				}
			};

			webSocket.onmessage = e => {
				const message = JSON.parse(e.data);
				_emitter.trigger(message.type, message);
			};

			webSocket.onerror = e => {
				_emitter.trigger('error', (e as any).data);
			};

			_socket = socket;
		}
	},

	setAuthToken: function (authToken) {
		_authToken = authToken;
	},

	connect: function (authToken) {
		if (!authToken) { throw new Error('authToken required to connect to socket'); }

		if (_socket && _socket.authToken !== authToken) {
			this.disconnect();
		}

		this.setAuthToken(authToken);
		this._tryConnect();
	},

	disconnect: function () {
		_authToken = undefined;
		clearTimeout(_connectTimeout);

		if (_socket) {
			_socket.innerSocket.close();
			_socket = null;
		}
	},

	sendMessage: function (type, payload) {
		if (_socket && _socket.isConnected) {
			_socket.innerSocket.send(JSON.stringify({ type: type, payload: payload }));
		}
	},

	isConnected: function () {
		return !!(_socket && _socket.isConnected);
	},

	getUniqueClientKey: function () {
		return _uniqueClientKey;
	},

	on: function (message, handler) {
		_emitter.on(message, handler);
	},

	off: function (message) {
		_emitter.off(message);
	}
};